<template>
  <div>

    <v-container fluid>

       <div v-if="from_coachup"
           style="width: 100%; display: flex; justify-content: center"
       >
          <div>
             Silly rabbit, coach ups are for managers. A goal to aspire to. Better luck next time.<br>
             ~ DealerKnows, out
          </div>

       </div>

       <div v-else style="width: 100%; text-align: center">
          Authorization Error.  You're not authorized to view this page.
       </div>





    </v-container>
  </div>
</template>
<script>
   export default {
      data() {
         return {
            from_coachup: false,
         };
      },

      created() {


         let from_path = this.$route.query.path
         console.log(from_path)

         if (from_path === '/coachup-que'){
            this.from_coachup = true;
         }


      }
   };
</script>
